import React from 'react'
import './Timeline.css'
import { useTranslation } from 'react-i18next'
import { MdImportExport } from 'react-icons/md'
import { RiPencilRuler2Line } from 'react-icons/ri'
import moment from 'moment'

const OtherPlantsCard = ({ data }) => {
    const { t } = useTranslation()

    const content = <>
        <div className="timeline-item-content">
            <span className="title">
                <MdImportExport className="icon" />
                {t('tlh.ippn.otherPlants.title')}
            </span>
            <div>
                <section className="container row">
                    <div className="item">
                        <span className="label">{t('tlh.ippn.otherPlants.numPurchaseOrder')}: </span>
                        <span className="value">
                            <span className="value">{data.detail['Purchase Order']}</span>
                        </span>
                    </div>
                    <div className="item">
                        <span className="label">{t('tlh.ippn.otherPlants.itemPurchaseOrder')}: </span>
                        <span className="value">{data.detail['Item Purchase Order']}</span>
                    </div>

                </section>
                <section className="container row">
                    <div className="item">
                        <span className="label">{t('tlh.ippn.otherPlants.project')}: </span>
                        <span className="value">{data.detail['Project']}</span>
                    </div>
                    <div className="item">
                        <span className="label">{t('tlh.ippn.otherPlants.supplier')}: </span>
                        <span className="value">{data.detail['Supplier']}</span>
                    </div>
                </section>
                <span className="container row" >
                    <RiPencilRuler2Line className="icon-base" />
                    {t('tlh.ippn.otherPlants.subtitle')}
                </span>
                <section className="container row">

                    <div className="item">
                        <span className="label">{t('tlh.ippn.otherPlants.odNominal')}: </span>
                        <span className="value">{data.detail['Od Nominal']}</span>
                    </div>
                    <div className="item">
                        <span className="label">{t('tlh.ippn.otherPlants.length')}: </span>
                        <span className="value">{data.detail['Lenght']}</span>
                    </div>

                </section>
                <section className="container row">
                    <div className="item">
                        <span className="label">{t('tlh.ippn.otherPlants.weight')}: </span>
                        <span className="value">{data.detail['Weight']}</span>
                    </div>
                    <div className="item">
                        <span className="label">{t('tlh.ippn.otherPlants.linearWeight')}: </span>
                        <span className="value">{data.detail['Linear Weight']}</span>
                        <span className="value">{data.detail['Linear Weigt Unit']}</span>
                    </div>

                </section>
                <section className="container row">


                    <div className="item">
                        <span className="label">{t('tlh.ippn.otherPlants.grade')}: </span>
                        <span className="value">{data.detail['Grade']}</span>
                    </div>

                    <div className="item">
                        <span className="label">{t('tlh.ippn.otherPlants.partNumber')}: </span>
                        <span className="value">{data.detail['Part Number']}</span>
                    </div>
                </section>
                <section className="container row">

                    <div className="item">
                        <span className="label">{t('tlh.ippn.otherPlants.connection')}: </span>
                        <span className="value">{data.detail['Connection']}</span>
                    </div>

                    <div className="item">
                        <span className="label">{t('tlh.ippn.otherPlants.range')}: </span>
                        <span className="value">{data.detail['Range']}</span>
                    </div>
                </section>
                <section>
                    <div className="item">
                        <span className="label">{t('tlh.ippn.otherPlants.source')}</span>
                        <span className="value">{data.detail['Source']}</span>
                    </div>
                </section>

                <span className="circle" > {moment(data.date).format('DD/MM/YYYY')} </span>
            </div>

        </div>
    </>
    return content
}

export default OtherPlantsCard